<template>
  <b-row>
    <b-col cols="12">
      <b-tabs
        justified
        pills
      >
        <b-tab>
          <template #title>
            <feather-icon icon="FileIcon" />
            Genel Bilgi
          </template>
          <b-card>
            <title-text />
            <title-content />
            <content-text />
            <ordering />
          </b-card>
          <logo-card />
        </b-tab>
        <b-tab>
          <template #title>
            <feather-icon icon="MailIcon" />
            CTA Yapılandırma
          </template>
          <b-card title="CTA Yapılandırma">
            <cta-title />
            <cta-text />
            <b-row>
              <b-col
                cols="12"
                md="3"
              >
                <cta-button />
              </b-col>
              <b-col>
                <cta-url />
              </b-col>
            </b-row>
          </b-card>
          <image-card />
        </b-tab>
        <b-tab>
          <template #title>
            <feather-icon icon="InfoIcon" />
            Seo Bilgileri
          </template>
          <seo-component data-store="brands/dataItem" />
        </b-tab>
      </b-tabs>
    </b-col>
    <b-col cols="12">
      <b-button
        variant="primary"
        :disabled="dataItem.submitStatus"
        @click="submitForm"
      >
        Kaydet
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
import {
  BCard, BCol, BRow, BButton, BTabs, BTab,
} from 'bootstrap-vue'
import TitleText from '@/views/Admin/Brands/elements/Title.vue'
import TitleContent from '@/views/Admin/Brands/elements/TitleContent.vue'
import ContentText from '@/views/Admin/Brands/elements/ContentText.vue'
import Ordering from '@/views/Admin/Brands/elements/Ordering.vue'
import LogoCard from '@/views/Admin/Brands/elements/LogoCard.vue'
import CtaTitle from '@/views/Admin/Brands/elements/CtaTitle.vue'
import CtaText from '@/views/Admin/Brands/elements/CtaText.vue'
import CtaButton from '@/views/Admin/Brands/elements/CtaButton.vue'
import CtaUrl from '@/views/Admin/Brands/elements/CtaUrl.vue'
import ImageCard from '@/views/Admin/Brands/elements/ImageCard.vue'
import SeoComponent from '@/layouts/components/common/SeoComponent.vue'

export default {
  name: 'ItemForm',
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BTabs,
    BTab,
    TitleText,
    TitleContent,
    ContentText,
    Ordering,
    LogoCard,
    CtaTitle,
    CtaText,
    CtaButton,
    CtaUrl,
    SeoComponent,
    ImageCard,
  },
  props: {
    submitForm: {
      type: Function,
      required: true,
    },
  },
  computed: {
    dataItem() {
      return this.$store.getters['brands/dataItem']
    },
  },
}
</script>
